import { apiService } from '@/services/api'

export interface ChatAutoCloseSettings {
  enabled: boolean
  idle_minutes: number
  auto_message: string
  close_message: string
  warning_message: string
  updated_by_admin_id?: number | null
  updated_at?: string | null
}

export interface ChatAutoCloseSettingsUpdate {
  enabled?: boolean
  idle_minutes?: number
  auto_message?: string
  close_message?: string
  warning_message?: string
}

export interface ArmAutoCloseResponse {
  chat_room_id: number
  armed_at: string
  armed_by_admin_id: number
}

class ChatAutoCloseSettingsService {
  async get(): Promise<ChatAutoCloseSettings> {
    const resp = await apiService.get<any>('/api/v1/admin/chat/auto-close-settings')
    return (resp?.data ?? resp) as ChatAutoCloseSettings
  }

  async update(payload: ChatAutoCloseSettingsUpdate): Promise<ChatAutoCloseSettings> {
    const resp = await apiService.put<any>('/api/v1/admin/chat/auto-close-settings', payload)
    return (resp?.data ?? resp) as ChatAutoCloseSettings
  }

  async arm(roomId: number): Promise<ArmAutoCloseResponse> {
    const resp = await apiService.post<any>(
      `/api/v1/admin/chat/auto-close-settings/rooms/${roomId}/arm`,
      {}
    )
    return (resp?.data ?? resp) as ArmAutoCloseResponse
  }

  async getState(roomId: number): Promise<{ chat_room_id: number; armed_at: string | null; armed_by_admin_id: number | null }> {
    const resp = await apiService.get<any>(
      `/api/v1/admin/chat/auto-close-settings/rooms/${roomId}/state`
    )
    return (resp?.data ?? resp)
  }
}

export const chatAutoCloseSettingsService = new ChatAutoCloseSettingsService()
export default chatAutoCloseSettingsService
